import { useContext } from 'react';
import ResourceDetailsContext from '../context/ResourceDetailsContext';

export default function useResourceDetailsContext() {
  return useContext(ResourceDetailsContext);
}
